import React from "react";
import Timeline from "../components/user/kombinezon/Timeline";
import KombinezonMain from "../components/user/kombinezon/KombinezonMain";
import KombinezonMain2 from "../components/user/kombinezon/KombinezonMain2";

const Kombinezon = () => {
  return (
    <div>
      <Timeline />

      <KombinezonMain />
    </div>
  );
};

export default Kombinezon;
